/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:30 GMT
 */
const tokens = {
    component: {
        divider: {
            styles: {
                solid: {
                    borderWidth: {
                        value: "1px",
                        type: "dimension",
                    },
                    borderStyle: {
                        value: "solid",
                        type: "strokeStyle",
                    },
                },
                dashed: {
                    borderWidth: {
                        value: "1px",
                        type: "dimension",
                    },
                    dash: {
                        value: "2px",
                        type: "dimension",
                    },
                    space: {
                        value: "2px",
                        type: "dimension",
                    },
                },
            },
            colors: {
                default: {
                    borderColor: {
                        value: "#dadada",
                        type: "color",
                    },
                },
                secondary: {
                    borderColor: {
                        value: "#6f7377",
                        type: "color",
                    },
                },
            },
        },
    },
};
export default tokens;
